import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="w-20 h-20 flex items-center justify-center bg-background-200 rounded-full mb-6">
        <i className="ri-error-warning-line text-foreground-400 text-3xl"></i>
      </div>
      <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-2">页面未找到</h1>
      <p className="text-sm text-foreground-500 mb-6">您访问的页面不存在，请检查网址或返回首页</p>
      <Link
        to="/"
        className="whitespace-nowrap px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors"
      >
        返回首页
      </Link>
    </div>
  );
}